import type { TemplateViewT } from 'src/ui/Template';
import type { ITemplatePageFields } from 'types/generated/contentful';

export const getTemplatePageProps = ({
  template,
  title,
  presentationId,
  questionId,
  slug,
}: ITemplatePageFields): TemplateViewT => ({
  title: template.fields.title ?? title,
  presentationId: template.fields?.presentationId ?? presentationId,
  questionId: template.fields?.questionId ?? questionId,
  preview: template.fields.preview?.fields?.file.url,
  slug,
  pro: template.fields.usesProFeatures,
});
